import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Header from '../header'
import Footer from '../footer'
import Helmet from 'react-helmet'

import layoutStyles from './Layout.module.css'
// Load global CSS style
import fromGatsbyStyles from './GatsbyNormalize.module.css'
import globalStyles from './LayoutGlobalStyle.module.css'

const Layout = ({ children, centered }) => {
  return (
    <>
      <Header />
      <main className={layoutStyles.main}>
        <div className={classNames({ [layoutStyles.centered]: centered })}>
          {children}
        </div>
      </main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
